import { styled } from 'styled-components';

import { COLORS, GRADIENTS, RETAILER_COLORS } from '@components/web/src/styles';

export const ProductFeedbackQuestionPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1;
  width: 100%;
  padding: 32px 16px 32px;
  background: ${GRADIENTS.secondaryGradient};
`;

export const ProductFeedbackQuestionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

export const StyledDot = styled.div<{ $isCurrentDotStyle: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $isCurrentDotStyle }) => ($isCurrentDotStyle ? RETAILER_COLORS.primary['25'] : COLORS.gray[900])};
  ${({ $isCurrentDotStyle }) => $isCurrentDotStyle && `border: 1px solid ${RETAILER_COLORS.primary['300']};`}
`;

export const QuestionHeaderWrapper = styled.div`
  width: 100%;
`;

export const StyledBlockOne = styled.div`
  display: flex;
  height: 10px;
  margin: 0 14px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border: 1px solid ${RETAILER_COLORS.primary['25']};
  background: ${RETAILER_COLORS.primary['100']};
  border-bottom: none;
`;

export const StyledBlockTwo = styled.div`
  display: flex;
  height: 12px;
  margin: 0 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border: 1px solid ${RETAILER_COLORS.primary['25']};
  background: ${RETAILER_COLORS.primary['100']};
  border-bottom: none;
`;
